import axios from '@/axios/globalaxios'

export const addResource = data =>{
    return axios({
        url: "/tradelab/resource/addResource",
        method: 'post',
        data:data
    })
}
//根据角色查资源
export const findResourceByRoleId = data =>{
  return axios({
      url: "/tradelab/resource/findResourceByRoleId",
      method: 'post',
      data:data
  })
}
export const saveRoleResource = data =>{
  return axios({
      url: "/tradelab/resource/saveRoleResource",
      method: 'post',
      data:data
  })
}
